<template>
  <div class="registration">
    <div class="container">
      <RegistrationForm
        @showTerms="showTerms"
        @showPrivecy="showPrivecy"
      ></RegistrationForm>
    </div>
  </div>
</template>

<script>
import RegistrationForm from "./registration/RegistrationForm";

export default {
  name: "Registration",
  components: {
    RegistrationForm
  },
  methods: {
    showTerms() {
      this.$emit("showTerms", true);
    },
    showPrivecy() {
      this.$emit("showPrivecy", true);
    }
  }
};
</script>

<style scoped>
.registration {
  max-width: 100%;
  width: 100vw;
  min-height: calc(100vh - 60px);
  background-color: transparent;
}
.registration-box {
  bottom: -60px;
  left: 60px;
}
@media (max-width: 768px) {
  .registration {
    background: url("../images/bg/sky-mobile.jpg");
  }
}
</style>
